import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
const { SENTRY_DSN, SENTRY_ENVIRONMENT, VERSION } = publicRuntimeConfig;

const ignoreErrors = [
    // Freshchat warning
    'Freshchat widget not available',
    // user got a 401 error, which is expected if they're not logged in
    'Request failed with status code 401',
    // user got a 403 error, which is expected if they're not logged in
    'Request failed with status code 403',
    // Intentionally triggered to prevent route change when unsaved changes are present
    'Please ignore this error.'
];

const sentryConfig = {
    dsn: SENTRY_DSN,
    release: VERSION,
    environment: SENTRY_ENVIRONMENT,
    sendDefaultPii: true,
    sourcemaps: {
        disable: true
    },
    ignoreErrors
};

export default sentryConfig;
